// extracted by mini-css-extract-plugin
export default {"message":"TextArea_message__TU-0j","decompte":"TextArea_decompte__kC9Lx"};